import SystemStatus from "../js/components/groupManagement/SystemStatus.react";
export default SystemStatus;
